import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { VALIDATION_DELAY } from '../../middlewares/formValidator';
import { getUITA, isTrue } from '../../utils/commonUtils';
import { submitForm } from '../actions/runtime.actions';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FORM_MODEL_ATTRIBUTES, SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { FCM_BUTTON_STYLES } from '../constants/runtime.constants';
import { getEvaluatedExpression } from '../selectors/form-manager.selectors';
import { isButtonDisabled } from '../selectors/runtime.selectors';

const useStyles = makeStyles(FCM_BUTTON_STYLES);

function SSButtonControlledPrintRequest({
  label,
  needSignature,
  commandName,
  commandArgument,
  formKey,
  isEditor,
  causesValidation,
  id,
  index,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
}) {
  const classes = useStyles({ isControlAddedFCM });
  const { pathname } = useLocation();
  const meaning = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    prop: FORM_MODEL_ATTRIBUTES.MEANING,
  });
  const isDisabled = useFormSelector(isButtonDisabled, {
    controlType: SS_CONTROL_TYPE.BUTTON_CONTROL_PRINT,
  });
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const translatedMeaning = translateString(meaning);

  const onClickHandler = () => {
    setTimeout(() => {
      dispatch(
        submitForm({
          formSubmitType: 'submit-control-print',
          commandName,
          commandArgument,
          needSignature: isTrue(needSignature),
          formKey,
          causesValidation,
          meaning: translatedMeaning,
          pathname,
        })
      );
    }, VALIDATION_DELAY);
  };

  return (
    <span
      className={isControlAddedFCM || isControlChangedFCM ? classes.changesModeWrapper : null}
      ui-ta={getUITA('FormCtrl', 'SSButtonControlledPrintRequest')}
      data-ss-id={id}
    >
      <Button
        variant="primary"
        color="primary"
        style={{ minWidth: '128px' }}
        onClick={onClickHandler}
        disabled={isEditor || isDisabled || isControlHiddenFCM}
      >
        {label || translateString('Request Print')}
      </Button>
      {isControlChangedFCM && (
        <span className={classes.changesIcon}>
          <ControlChangesIcon id={id} />
        </span>
      )}
    </span>
  );
}

export default SSButtonControlledPrintRequest;
